import {Avatar, Button, List, Tag, Typography} from "antd";


export const SearchResultList = ({ count, data, isLoading, setListSwitcher, listSwitcher = null }) => {
  return(
    <List
      header={<div style={{ textAlign: 'center' }}>
        <Typography.Text strong style={{ fontSize: 20 }}>Refine Search Results</Typography.Text>
      </div>}
      size="large"
      loading={isLoading}
      bordered
      dataSource={Object.keys(data)}
      renderItem={item => (
        <List.Item style={listSwitcher === item ? { background: '#d3ffc6' } : {}}>
          <List.Item.Meta
            avatar={<Avatar
              style={{ color: '#f56a00', backgroundColor: '#fde3cf' }}
            >
              {item[0].toUpperCase()}
            </Avatar>}
            title={<Button onClick={() => setListSwitcher(item)} type="link">{item[0].toUpperCase() + item.substring(1)}</Button>}
          />
          <Tag color="#108ee9">{count && count[item]}</Tag>
        </List.Item>
      )}
    />
  )
}